import { Component, OnInit } from '@angular/core';
import { MapNavigation } from "../../map/map-navigation/map-navigation";
import { ActivatedRoute } from '@angular/router';
import { Incident } from '../../models/incident';
import { IncidentService } from '../../shared/incident.service';

@Component({
  selector: 'app-incident-navigate',
  imports: [MapNavigation],
  templateUrl: './incident-navigate.html',
  styleUrl: './incident-navigate.less'
})
export class IncidentNavigateComponent implements OnInit {
  destinationCoords = { lat: -31.78015, lng: 18.635787 }; //Somewhere on N4
  isLoading: boolean = true;
  

  constructor(private route: ActivatedRoute
    ,private incidentService: IncidentService
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      
      const incidentId = +params['incidentId'];
      const searchedIncident = this.incidentService.openIncidents().find(incident => incident.incidentId === incidentId);
      if (searchedIncident) {
        this.destinationCoords = { lat: searchedIncident.location.latitude, lng: searchedIncident.location.longitude };
        this.isLoading = false;
      }
    });
  }

}
